import { GenericServices } from "./generic.services";
import Uri from "../common/uri/message-notification.constants";
import { MessageNotificationResquest, MessageNotificationResponse, IMessageNotificationModel } from "../models/message-notification/index";
import { deepCopy } from "../utils/util";
import { ApiResponse } from "../models/app-configuration/api-response-handler";

export interface IMessageNotificationServices {
    search: (request: MessageNotificationResquest) => Promise<ApiResponse<MessageNotificationResponse>>;
    read: (request: MessageNotificationResquest) => Promise<ApiResponse<MessageNotificationResponse>>;
    getUnreadIds(request: MessageNotificationResquest): Promise<ApiResponse<number[]>>;
    readOne: (messageId: number) => Promise<ApiResponse<MessageNotificationResponse>>;
    detail: (messageId: number) => Promise<IMessageNotificationModel>;
}

export class MessageNotificationServices extends GenericServices implements IMessageNotificationServices {

    constructor() {
        super();
    }

    search(request: MessageNotificationResquest): Promise<ApiResponse<MessageNotificationResponse>> {
        const cloneRequest = deepCopy(request);
        cloneRequest.Fields = "*";
        cloneRequest.OrderBy = "-Id";
        cloneRequest.ViewMode = "Grid";
        return super.executeSelectingPost(cloneRequest, Uri.postSearch)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => Promise.reject(ex));
    }

    getUnreadIds(request: MessageNotificationResquest): Promise<ApiResponse<number[]>> {
        const cloneRequest = deepCopy(request);
        cloneRequest.Fields = "Id";
        cloneRequest.OrderBy = "-Id";        
        cloneRequest.ViewMode = "Grid";
        cloneRequest.Condition.IsRead = false;
        return super.executeSelectingPost(cloneRequest, Uri.postSearch)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data.listOfItems.map(x => x.Id));
                }
                return Promise.reject(response.message);
            })
            .catch(ex => Promise.reject(ex));
    }

    read(request: MessageNotificationResquest): Promise<ApiResponse<MessageNotificationResponse>> {
        const cloneRequest = deepCopy(request);
        cloneRequest.Fields = "*";
        cloneRequest.OrderBy = "-Id";
        cloneRequest.ViewMode = "Grid";
        return super.executeSelectingPost(cloneRequest, Uri.postRead)
            .then((response: ApiResponse) => {
                return Promise.resolve(response);
            })
            .catch(ex => Promise.reject(ex));
    }

    readOne(id: number): Promise<ApiResponse<MessageNotificationResponse>> {
        const request = new MessageNotificationResquest();
        request.Fields = "*";
        request.OrderBy = "-Id";
        request.ViewMode = "Grid";
        request.Condition.Ids = [id];
        return super.executeSelectingPost(request, Uri.postRead)
            .then((response: ApiResponse) => {
                return Promise.resolve(response);
            })
            .catch(ex => Promise.reject(ex));
    }

    detail(messageId: number): Promise<IMessageNotificationModel> {
        const url = Uri.getDetail.replace(':id', messageId.toString());
        return super.executeSelecting(undefined, url)
            .then((response: ApiResponse) => {
                if (response.isSuccess) {
                    return Promise.resolve(response.data);
                }
                return Promise.reject(response.message);
            })
            .catch(ex => Promise.reject(ex));
    }
}